import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import LogoSupremacyBig from "../../../assets/assets/elevva-mora_big.png";
import { instance, laptop1600, Loadingspinner } from "../../../utils/utils";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import Step7 from "./info/steep-7";
import Step2 from "./info/step-2";
import Step3 from "./info/step-3";
import Step4 from "./info/step-4";
import Step5 from "./info/step-5";
import Step6 from "./info/step-6";
import Step7Test from "./info/step-7-test";
import PersonalInfo from "./personal-info";
import ConfirmDeletionModal from "../../Mob/components/modal-delete";
import ModalInfoPreValuations from "./modal-info-pre-valuations";
import PreValuationSteps from "./pre-valuations-step";

const AthleteInfo = ({ edit }) => {
  const { id } = useParams();

  const [loading, setLoading] = useState(false);
  const [originalData, setOriginalData] = useState(null);
  const [modalError, setModalError] = useState(null);
  const [formData, setFormData] = useState(null);
  const [modal, setModal] = useState(null);
  function getValorationUser() {
    setLoading(true);
    instance
      .get(
        `customers/corp/medical/evaluation/${
          edit ? "" : "ready"
        }?customer_id=${id}`
      )
      .then((res) => res.data)
      .then((data) => {
        console.log(data);
        setOriginalData(data);
        setFormData(JSON.parse(JSON.stringify(data)));
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setModalError(
          <ConfirmDeletionModal
            zIndex={1000}
            onCancel={() => setModalError(null)}
            onConfirm={() => setModalError(null)}
            loader={false}
          >
            {err.response?.data?.error ||
              err.response?.data ||
              "Error al obtener la información del atleta."}
          </ConfirmDeletionModal>
        );
      });
  }

  // useEffect(() => {
  //   getValorationUser();
  // }, []);

  useEffect(() => {
    edit
      ? setModal(
          <ModalInfoPreValuations
            onCancel={() => setModal(null)}
            onConfirm={() => {
              setModal(null);
              getValorationUser();
            }}
            loader={false}
            buttonConfirm={true}
            buttonConfirmText="Guardar y continuar"
            buttonCancelText="Cancelar"
            buttonsWidth="80%"
            maxWidth="50rem"
          >
            <PerfectScrollbar
              style={{ height: laptop1600.matches ? "" : "30rem" }}
            >
              <div className="d-flex flex-column ">
                <PreValuationSteps
                  onCancel={() => setModal(null)}
                  onConfirm={() => {
                    setModal(null);
                    getValorationUser();
                  }}
                />
              </div>{" "}
            </PerfectScrollbar>
          </ModalInfoPreValuations>
        )
      : getValorationUser();
  }, [edit]);

  return (
    <div
      style={{
        flexGrow: "1",
        display: "flex",
        flexDirection: "column",
        position: "relative",
      }}
    >
      {modalError}
      {modal}
      <div
        className="d-flex position-relative"
        style={{
          height: "60px",
          background: "var(--backgroundOnboarding)",
          columnGap: "2rem",
        }}
      >
        <div className="logo-supremacy">
          <img style={{ width: "6rem" }} src={LogoSupremacyBig}></img>
        </div>
      </div>
      <div
        className="d-flex flex-column p-3"
        style={{
            height: "calc(100% - 60px)",
            width: "calc(100vw - 65px)",
            backgroundColor: "white",
            borderRadius: "10px",
      }}
      >
        <div
          className=" text-center h-100 w-100 p-2"
          style={{
            border: "1px solid #B6C1CE",
            borderRadius: "10px",
          }}
        >
          {loading ? (
            <Loadingspinner size={"2.5rem"} />
          ) : (
            <div className="h-100 w-100">
              <PersonalInfo
                setFormData={setFormData}
                userDetail={formData}
                edit={edit}
                firstText={"Información"}
                secondText={"del atleta"}
              />
              <div className="d-flex px-3 " style={{ height: "38%" }}>
                <Step2
                  edit={edit}
                  userDetail={formData}
                  setFormData={setFormData}
                />
                <Step3
                  edit={edit}
                  userDetail={formData}
                  setFormData={setFormData}
                />
              </div>
              <div
                className="d-flex pt-3 px-3 flex-grow-1 "
                style={{ height: "50%" }}
              >
                <div style={{ width: "25%" }}>
                  <Step4
                    edit={edit}
                    userDetail={formData}
                    setFormData={setFormData}
                  />
                </div>
                <div style={{ width: "30%" }}>
                  <Step5 userDetail={formData} />
                </div>
                <div style={{ width: "20%" }}>
                  <Step6
                    edit={edit}
                    userDetail={formData}
                    setFormData={setFormData}
                  />
                </div>
                <div style={{ width: "25%" }}>
                  {edit ? (
                    <Step7Test
                      userDetail={formData}
                      setFormData={setFormData}
                    />
                  ) : (
                    <Step7 userDetail={formData} setFormData={setFormData} />
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AthleteInfo;
